import React from 'react';
import i18n from '../../i18n/i18n.js';
import TypedLink from '../TypedLink/TypedLink.js';
import SlideDownContent from '../AnimatedElements/SlideDownContent.js';
import { ReactSVG } from "react-svg";

import './HeaderBanner.css';

class HeaderBanner extends React.Component {

  banner_data = {
    text: '',
    url: '',
    type: '',
    slide_content: '',
  }

  animationObjectRef = new React.createRef();

  constructor(props) {
    super(props);

    this.banner_data.text = props.text ? props.text : '';
    this.banner_data.url = props.url ? props.url : '';
    this.banner_data.type = props.type ? props.type : '';
    this.banner_data.slide_content = props.children ? props.children : '';
    
    this.state = {
      open: false
    };
  }

  toggleSlide() {
    const open = this.state.open;

    this.setState({open: !open}, () => {
      this.animationObjectRef.current.setVisible(this.state.open);
    });
  }

  render() {
    const open = this.state.open;
    const props = this.props;

    return <div className='header-banner-container'>
      <div className='header-banner'>
        {this.banner_data.url
          ? <TypedLink link={{type:this.banner_data.type, url: this.banner_data.url, title: this.banner_data.text}}></TypedLink>
          : <div className='slide-banner'>
              <p onClick={() => this.toggleSlide()}>{this.banner_data.text}</p>
              {this.banner_data.slide_content
                ? <ReactSVG className='slide-icon' src={`assets/images/${open ? 'scissors_open' : 'scissors'}.svg`} onClick={() => this.toggleSlide()} />
                : ''}
            </div>
        }
      </div>

      {this.banner_data.slide_content
        ? <SlideDownContent ref={this.animationObjectRef} className="slide-content">{this.banner_data.slide_content}</SlideDownContent>
        : ''}
    </div>
  }
};

export default HeaderBanner;

